import type { ExperimentDef, ExperimentKey } from '../types';
import { mountSurveyExplorer } from './survey-explorer';
import { mountDistributionSculptor } from './distribution-sculptor';
import { mountTwoVariableLab } from './two-variable-lab';
import { mountSamplingLab } from './sampling-lab';
import { mountProbabilityDiagrams } from './probability-diagrams';

export const EXPERIMENTS: Record<ExperimentKey, ExperimentDef> = {
  'survey-explorer': {
    labelKey: 'exp.survey-explorer.title',
    params: [],
    mount: mountSurveyExplorer,
  },
  'distribution-sculptor': {
    labelKey: 'exp.distribution-sculptor.title',
    params: [],
    mount: mountDistributionSculptor,
  },
  'two-variable-lab': {
    labelKey: 'exp.two-variable-lab.title',
    params: [],
    mount: mountTwoVariableLab,
  },
  'sampling-lab': {
    labelKey: 'exp.sampling-lab.title',
    params: [],
    mount: mountSamplingLab,
  },
  'probability-diagrams': {
    labelKey: 'exp.probability-diagrams.title',
    params: [],
    mount: mountProbabilityDiagrams,
  },
};
